import { useMutation, useQuery } from "react-query";
import { ChargeSessionService } from "./charge-session.service";
import toast from "react-hot-toast";

// GET List
const useGetList = (page: number, query?: Record<string, any>, options?: { enabled?: boolean }) => {
  return useQuery(
    ["listSession", page, query],
    async () => {
      const { data } = await ChargeSessionService.getListChargeSession({
        page,
        ...query,
      });
      return data;
    },
    { 
      keepPreviousData: true,
      enabled: options?.enabled ?? true 
    },
  );
};

const useStatisticsByCharger = (
  params: {
    page?: number;
    per_page?: number;
    from_date?: string;
    to_date?: string;
    charger_type?: "ac" | "dc" | "unknown" | "all";
    status?: "active" | "inactive" | "all";
    type?: "by-charger";
  } = {},
) => {
  return useQuery(
    ["statisticsByCharger", params],
    async () => {
      const { data } = await ChargeSessionService.getStatisticsByCharger(params);
      return data;
    },
    {
      keepPreviousData: true,
    },
  );
};


const useStatisticsByLocation = (
  params: {
    page?: number;
    per_page?: number;
    from_date?: string;
    to_date?: string;
    CPO?: string;
    SeedingPartner?: string;
    type?: "location-performance";
  } = {},
) => {
  return useQuery(
    ["statisticsByLocation", params],
    async () => {
      const { data } = await ChargeSessionService.getStatisticsByLocation(params);
      return data;
    },
    {
      keepPreviousData: true,
    },
  );
};

const useStatisticsChargingSessionPerformance = (
  params: {
    page?: number;
    per_page?: number;
    session_id?: string;
    status?: string;
    from_date?: string;
    to_date?: string;
    CPO?: string;
    SeedingPartner?: string;
    type?: "charging-session-performance";
  } = {},
) => {
  return useQuery(
    ["statisticsChargingSessionPerformance", params],
    async () => {
      const { data } = await ChargeSessionService.getStatisticsChargingSessionPerformance(
        params,
      );
      return data;
    },
    {
      keepPreviousData: true,
    },
  );
};

// GET Detail
const useGetDetail = (id: string) => {
  return useQuery(["getDetail", id], async () => {
    const { data } = await ChargeSessionService.getDetailChargeSession(id);
    return data;
  });
};

const useGetSettleEnergy = (id: string) => {
  return useQuery(["getSettleEnergy", id], async () => {
    if (id) {
      const { data } =
        await ChargeSessionService.getSettleEnergyChargeSession(id);
      return data;
    }

    return [];
  });
};

// const useSettleEnergyApply = (id: string) => {
//   return useQuery(["getSettleEnergy", id], async () => {
//     const { data } = await ChargeSessionService.applySettleEnergyChargeSession(id);
//     return data;
//   });
// };

const useSettleEnergyApply = (cb?: (data: any) => void) => {
  return useMutation(
    async (payload: any) => {
      const data =
        await ChargeSessionService.applySettleEnergyChargeSession(payload);
      return data;
    },
    {
      onSuccess: (data) => {
        cb?.(data);
        if (data.ok) {
          toast.success("Invalidate successfully!");
        } else {
          toast.error(data?.msg);
        }
      },
      onError(error, _variables, _context) {
        alert(error);
      },
    },
  );
};

const useFlushSession = (_cb?: (data: any) => void) => {
  return useMutation(
    async (payload: any) => {
      const data =
        await ChargeSessionService.flushSession(payload);
      return data;
    }
  );
};


export {
  useGetList,
  useGetDetail,
  useGetSettleEnergy,
  useSettleEnergyApply,
  useFlushSession,
  useStatisticsByLocation,
  useStatisticsByCharger,
  useStatisticsChargingSessionPerformance,
};
